import { Controller } from "@hotwired/stimulus";

// walk/DONATE.md screen 0, "Near me".
//
// The browser's coordinates go to the server ONCE, rounded to a town's worth
// (0.1°, about 11km). The server turns them into ?near=<town> and redirects,
// so what stays in history and in logs names a town, not a person. The button
// only appears where the browser can actually be asked.
export default class extends Controller {
  static targets = ["button", "lat", "lng", "denied"];

  connect() {
    if ("geolocation" in navigator) this.buttonTarget.hidden = false;
  }

  locate(event) {
    event.preventDefault();
    this.buttonTarget.disabled = true;
    navigator.geolocation.getCurrentPosition(
      ({ coords }) => {
        this.latTarget.value = coords.latitude.toFixed(1);
        this.lngTarget.value = coords.longitude.toFixed(1);
        this.element.requestSubmit();
      },
      () => {
        this.buttonTarget.disabled = false;
        this.deniedTarget.hidden = false;
      },
      { enableHighAccuracy: false, maximumAge: 600000, timeout: 10000 },
    );
  }
}
